/**
 * QA-124 — `<input type="datetime-local" step="1">` 표시값 ↔ BE Instant(ISO 'Z') 변환.
 *
 * 분 단위만 다루는 `datetimeLocal.ts` 와 달리 **초까지** 보존한다(발표 노출 시각 지정).
 * datetime-local(step=1) 은 초/타임존이 없는 'YYYY-MM-DDTHH:mm:ss' 를, 비울 때는 '' 을 낸다.
 * BE Instant 는 'Z'/offset 이 없으면 Jackson 파싱이 실패하므로 전송 직전 toISOString() 으로 정규화한다.
 */

/** datetime-local('YYYY-MM-DDTHH:mm[:ss]') / 풀 ISO / '' → Instant('...Z') | null. 빈/파싱불가 → null. */
export const localSecondsToInstant = (v: string | null | undefined): string | null => {
  if (v == null || v === '') return null;
  const d = new Date(v);
  return Number.isNaN(d.getTime()) ? null : d.toISOString();
};

/** BE Instant('...Z') → datetime-local 표시값('YYYY-MM-DDTHH:mm:ss', 로컬시각, 초 포함). 빈/파싱불가 → ''. */
export const instantToLocalSeconds = (v: string | null | undefined): string => {
  if (!v) return '';
  const d = new Date(v);
  if (Number.isNaN(d.getTime())) return '';
  const pad = (n: number) => String(n).padStart(2, '0');
  return (
    `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}` +
    `T${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`
  );
};

/** datetime-local('YYYY-MM-DDTHH:mm:ss') → 'YYYY-MM-DD' 날짜 부분만(목록 표기 publishedAt 용). 빈 → ''. */
export const localSecondsToDate = (v: string | null | undefined): string => {
  if (!v) return '';
  const m = /^(\d{4}-\d{2}-\d{2})/.exec(v);
  return m?.[1] ?? '';
};
